<template>
  <el-dialog
    title="智能分组设置"
    :visible.sync="groupManageInfo.show"
    v-if="groupManageInfo.show"
    width="70%"
    :close-on-click-modal="false"
  >
    <el-form size="small" label-position="right" label-width="80px">
      <div class="tip_msg" v-if="info.hasGroup">
        当前班级已存在分组，点击“开始分组”按钮会解散现有分组后重新分组。
      </div>
      <el-table
        :row-style="{ color: '#51627D', fontWeight: 400 }"
        :header-cell-style="{
          background: '#DCE7FA',
          color: '#343C4A',
          fontWeight: 500,
        }"
        :data="info.classLineGroupItemVoList"
        border
        style="width: 100%"
      >
        <el-table-column prop="lineName" width="200" label="所属条线">
        </el-table-column>
        <el-table-column prop="enrollNum" width="130" label="学员数量"> </el-table-column>
        <el-table-column width="130" label="分组数" align="center">
          <template slot-scope="scope">
            <el-input
              oninput="value=value.replace(/[^0-9]/g,'')"
              v-model="scope.row.groupNum"
              placeholder="分组数"
              :max="scope.row.enrollNum"
              @change="(val) => changeGroupNum(val, scope.row)"
              type="number"
              :min="0"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          width="130"
          prop="groupSize"
          label="最大分组人数"
          align="center"
        ></el-table-column>
        <el-table-column
          width="240"
          prop="ruleType"
          label="分配规则"
          align="center"
        >
          <template slot-scope="scope">
            <el-radio-group
               :key="'radio_' + scope.row.lineId"
              v-model="scope.row.ruleType"
              style="text-align: left; line-height: 1.4rem; padding-top: 6px;"
            >
              <el-radio
                v-for="item in ruleTypeData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn
        btntype="primary"
        @click.native="sureSubmit"
        title="开始分组"
        v-permission="'group:line:save'"
      ></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { groupLineInfoSave, groupLineInfo } from "@/api/class";

export default {
  components: { butn },
  props: {
    groupManageInfo: {
      type: Object,
      default: () => {},
    },
    classId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      info: {},
      ruleTypeData: [
        {
          paramKey: 1,
          paramValue: "优先从第一组开始分配",
        },
        {
          paramKey: 2,
          paramValue: "每组平均分配",
        },
      ],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      groupLineInfo({ classId: this.classId }).then(({ code, data }) => {
        if (code !== 0) return;
        let info = data;
        for (let i = 0; i < data.classLineGroupItemVoList.length; i++) {
          info.classLineGroupItemVoList[i].classId = this.classId;
          if (!data.classLineGroupItemVoList[i].ruleType) {
            info.classLineGroupItemVoList[i].ruleType = 1;
          }
          if (!data.classLineGroupItemVoList[i].groupNum) {
            info.classLineGroupItemVoList[i].groupNum = "";
          }
          if (!data.classLineGroupItemVoList[i].groupSize) {
            info.classLineGroupItemVoList[i].groupSize = "";
          }
        }
        this.info = info;
      });
    },
    // 修改分组数
    changeGroupNum(val, row) {
      if (val != "") {
        if (Number(val) > row.enrollNum) {
          row.groupNum = "";
          row.groupSize = "";
          return this.$message.error("分组数不能大于学员数！");
        }
        row.groupNum = val;
        if (Number(val) !== 0) {
          row.groupSize = Math.ceil(row.enrollNum / row.groupNum);
        } else row.groupSize = "";
      } else {
        row.groupNum = "";
        row.groupSize = "";
      }
    },
    closeDia() {
      this.$emit("closeDia", false);
    },
    sureSubmit() {
      let dataList = this.info.classLineGroupItemVoList;
      let flag = true;
      for (let i = 0; i < dataList.length; i++) {
        if (!dataList[i].groupNum) {
          flag = false;
          break;
        }
      }
      if (!flag) {
        this.$message.error("请设置所有所属条线的分组数");
      } else {
        if (this.info.hasGroup) {
          this.$confirm(`当前班级已存在分组，确定解散现有分组后重新分组吗？`,
            "系统提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(() => {
              this.loading = true;
              groupLineInfoSave(dataList).then(({ code, msg }) => {
                this.loading = false;
                if (code !== 0) return;
                this.$message.success(msg);
                this.$emit("closeDia", true);
              });
            })
            .catch(() => {});
        } else {
          groupLineInfoSave(dataList).then(({ code, msg }) => {
            if (code !== 0) return;
            this.$message.success(msg);
            this.$emit("closeDia", true);
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tip_msg {
  margin-bottom: 16px;
}
</style>
